'use client';

import { createContext, useContext } from 'react';

export type ViewMode = 'scroll' | 'fit';

interface VisualizationContextValue {
  viewMode: ViewMode;
  isFullscreen: boolean;
  /** Scale factor for fit mode (0-1, where 1 is full size) */
  scale: number;
  /** Container width for calculating scale */
  containerWidth: number;
}

const VisualizationContext = createContext<VisualizationContextValue>({
  viewMode: 'scroll',
  isFullscreen: false,
  scale: 1,
  containerWidth: 800,
});

export const VisualizationProvider = VisualizationContext.Provider;

export function useVisualizationContext() {
  return useContext(VisualizationContext);
}
